export default "__VITE_ASSET__CiSmvg0f__"